// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-sidebar-search-routingProfiles-RoutingProfiles-module__profilesParent {
    display: flex;
    flex-direction: row;
    padding: 0.7em 0 0.1em 0;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__carousel {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    padding: 0 2rem;
    box-sizing: border-box;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__profiles {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    overflow: scroll;
    gap: 0.1rem;

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    scrollbar-width: none;

    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
        display: none;
    }
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__profiles_center {
    justify-content: center;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__chevron {
    cursor: pointer;
    display: none;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabled {
    display: inline-block;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__chevron svg path {
    fill: #000000;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__chevron:disabled svg path {
    fill: lightgray;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__flip {
    transform: scaleX(-1);
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__selectedProfile {
    background-color: rgba(39, 93, 173, 0.2);
    color: #275dad;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__selectedProfile:hover {
    color: #275dad;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__profileBtn {
    position: relative;
    border-radius: 50%;
    padding: 0.3em;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__iconContainer {
    position: relative;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__batchNumber {
    position: absolute;
    top: -7.1px;
    right: -5px;
    font-size: 0.75em;
    font-weight: bold;
    -webkit-text-stroke: 2px #fff;
    paint-order: stroke fill;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__asIndicator {
    position: absolute;
    fill: none;
    stroke: #193b6e;
    left: -20px;
    top: -41px;
    z-index: 1;
    scale: 0.1;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox,
.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox {
    position: absolute;
    border-radius: 50%;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox svg path,
.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox svg path {
    fill: #a8a8a8;
    stroke: #a8a8a8;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox:active svg path,
.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox:active svg path {
    fill: lightgray;
    stroke: lightgray;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox:hover svg path,
.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox:hover svg path {
    fill: #000000;
    stroke: #000000;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox:active svg path,
.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox:active svg path {
    fill: lightgray;
    stroke: lightgray;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox svg,
.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox svg {
    margin: 0;
    padding: 8px;
    width: 18px;
    height: 18px;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox svg {
    transform: rotate(0);
    animation-name: src-sidebar-search-routingProfiles-RoutingProfiles-module__reverse_rotate;
    animation-duration: 0.2s;
}

.src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox svg {
    transform: rotate(180deg);
    animation-name: src-sidebar-search-routingProfiles-RoutingProfiles-module__setting_rotate;
    animation-duration: 0.2s;
}

@keyframes src-sidebar-search-routingProfiles-RoutingProfiles-module__setting_rotate {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(180deg);
    }
}

@keyframes src-sidebar-search-routingProfiles-RoutingProfiles-module__reverse_rotate {
    0% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/sidebar/search/routingProfiles/RoutingProfiles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;;IAEX,4CAA4C;IAC5C,wBAAwB;IACxB,qBAAqB;;IAErB,gDAAgD;IAChD;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,UAAU;IACV,UAAU;IACV,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,yFAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,yFAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".profilesParent {\n    display: flex;\n    flex-direction: row;\n    padding: 0.7em 0 0.1em 0;\n}\n\n.carousel {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0 2rem;\n    box-sizing: border-box;\n}\n\n.profiles {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    overflow: scroll;\n    gap: 0.1rem;\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    &::-webkit-scrollbar {\n        display: none;\n    }\n}\n\n.profiles_center {\n    justify-content: center;\n}\n\n.chevron {\n    cursor: pointer;\n    display: none;\n}\n\n.enabled {\n    display: inline-block;\n}\n\n.chevron svg path {\n    fill: #000000;\n}\n\n.chevron:disabled svg path {\n    fill: lightgray;\n}\n\n.flip {\n    transform: scaleX(-1);\n}\n\n.selectedProfile {\n    background-color: rgba(39, 93, 173, 0.2);\n    color: #275dad;\n}\n\n.selectedProfile:hover {\n    color: #275dad;\n}\n\n.profileBtn {\n    position: relative;\n    border-radius: 50%;\n    padding: 0.3em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n.iconContainer {\n    position: relative;\n}\n\n.batchNumber {\n    position: absolute;\n    top: -7.1px;\n    right: -5px;\n    font-size: 0.75em;\n    font-weight: bold;\n    -webkit-text-stroke: 2px #fff;\n    paint-order: stroke fill;\n}\n\n.asIndicator {\n    position: absolute;\n    fill: none;\n    stroke: #193b6e;\n    left: -20px;\n    top: -41px;\n    z-index: 1;\n    scale: 0.1;\n}\n\n.enabledCMBox,\n.cmBox {\n    position: absolute;\n    border-radius: 50%;\n}\n\n.enabledCMBox svg path,\n.cmBox svg path {\n    fill: #a8a8a8;\n    stroke: #a8a8a8;\n}\n\n.enabledCMBox:active svg path,\n.cmBox:active svg path {\n    fill: lightgray;\n    stroke: lightgray;\n}\n\n.cmBox:hover svg path,\n.enabledCMBox:hover svg path {\n    fill: #000000;\n    stroke: #000000;\n}\n\n.cmBox:active svg path,\n.enabledCMBox:active svg path {\n    fill: lightgray;\n    stroke: lightgray;\n}\n\n.enabledCMBox svg,\n.cmBox svg {\n    margin: 0;\n    padding: 8px;\n    width: 18px;\n    height: 18px;\n}\n\n.cmBox svg {\n    transform: rotate(0);\n    animation-name: reverse_rotate;\n    animation-duration: 0.2s;\n}\n\n.enabledCMBox svg {\n    transform: rotate(180deg);\n    animation-name: setting_rotate;\n    animation-duration: 0.2s;\n}\n\n@keyframes setting_rotate {\n    0% {\n        transform: rotate(0);\n    }\n    100% {\n        transform: rotate(180deg);\n    }\n}\n\n@keyframes reverse_rotate {\n    0% {\n        transform: rotate(180deg);\n    }\n    100% {\n        transform: rotate(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profilesParent": `src-sidebar-search-routingProfiles-RoutingProfiles-module__profilesParent`,
	"carousel": `src-sidebar-search-routingProfiles-RoutingProfiles-module__carousel`,
	"profiles": `src-sidebar-search-routingProfiles-RoutingProfiles-module__profiles`,
	"profiles_center": `src-sidebar-search-routingProfiles-RoutingProfiles-module__profiles_center`,
	"chevron": `src-sidebar-search-routingProfiles-RoutingProfiles-module__chevron`,
	"enabled": `src-sidebar-search-routingProfiles-RoutingProfiles-module__enabled`,
	"flip": `src-sidebar-search-routingProfiles-RoutingProfiles-module__flip`,
	"selectedProfile": `src-sidebar-search-routingProfiles-RoutingProfiles-module__selectedProfile`,
	"profileBtn": `src-sidebar-search-routingProfiles-RoutingProfiles-module__profileBtn`,
	"iconContainer": `src-sidebar-search-routingProfiles-RoutingProfiles-module__iconContainer`,
	"batchNumber": `src-sidebar-search-routingProfiles-RoutingProfiles-module__batchNumber`,
	"asIndicator": `src-sidebar-search-routingProfiles-RoutingProfiles-module__asIndicator`,
	"enabledCMBox": `src-sidebar-search-routingProfiles-RoutingProfiles-module__enabledCMBox`,
	"cmBox": `src-sidebar-search-routingProfiles-RoutingProfiles-module__cmBox`,
	"reverse_rotate": `src-sidebar-search-routingProfiles-RoutingProfiles-module__reverse_rotate`,
	"setting_rotate": `src-sidebar-search-routingProfiles-RoutingProfiles-module__setting_rotate`
};
export default ___CSS_LOADER_EXPORT___;
